/* LCT — Compteur de la liste de souhaits (header)
   L'app Wishlist Engine compte chaque variante enregistrée : un produit enregistré
   avec 2 variantes compte pour 2, alors qu'il n'apparaît qu'une fois dans la liste.

   Chiffre affiché :
   - sur la page liste de souhaits : le nombre d'articles réellement affichés ;
     on mémorise alors l'écart avec le chiffre de l'app ;
   - ailleurs : le chiffre de l'app moins cet écart (ou, à défaut, moins les variantes
     en double lues dans son cookie).

   On ne touche pas au texte écrit par l'app (sinon elle le réécrit et les deux chiffres
   clignotent) : notre chiffre est posé dans un attribut, affiché en CSS à la place du sien. */
(() => {
    if (window.__lctWishlistCount) return;
    window.__lctWishlistCount = true;

    const style = document.createElement('style');
    style.textContent = `
    .wishlist-total-count[data-lct-count] { font-size: 0 !important; }
    .wishlist-total-count[data-lct-count]::after {
      content: attr(data-lct-count);
      font-size: var(--lct-wc-size, 1.1rem);
    }`;
    document.head.appendChild(style);

    let pageCount = null; // fixé par la page liste de souhaits

    // Nombre de variantes « en trop » : produits enregistrés avec plusieurs variantes
    const duplicates = () => {
        const match = document.cookie.match(/(?:^|;\s*)WISHLIST_PRODUCTS_IDS=([^;]+)/);
        if (!match) return 0;
        try {
            const data = JSON.parse(decodeURIComponent(match[1])) || {};
            return Object.values(data).reduce((sum, p) => sum + Math.max((p?.variants?.length || 1) - 1, 0), 0);
        } catch (e) {
            return 0;
        }
    };

    // Écart mémorisé sur la page liste de souhaits entre le chiffre de l'app et les articles
    // réellement affichés (variantes en double, variantes supprimées…). Il reste valable
    // quand on ajoute ou retire ensuite des produits depuis les autres pages.
    const OFFSET_KEY = 'lct-wishlist-offset';
    const readOffset = () => {
        try {
            const value = parseInt(localStorage.getItem(OFFSET_KEY), 10);
            return Number.isNaN(value) ? null : value;
        } catch (e) {
            return null;
        }
    };
    const saveOffset = (value) => {
        try {
            localStorage.setItem(OFFSET_KEY, String(value));
        } catch (e) {
            /* stockage indisponible : on retombera sur le calcul par le cookie */
        }
    };

    const apply = () => {
        document.querySelectorAll('.wishlist-total-count').forEach((el) => {
            const appCount = parseInt(el.textContent, 10);
            let count = pageCount;
            if (count !== null) {
                if (!Number.isNaN(appCount)) saveOffset(Math.max(appCount - count, 0));
            } else {
                if (Number.isNaN(appCount)) {
                    el.removeAttribute('data-lct-count');
                    return;
                }
                const offset = readOffset();
                count = Math.max(appCount - (offset !== null ? offset : duplicates()), 0);
            }
            if (!el.style.getPropertyValue('--lct-wc-size')) {
                el.style.setProperty('--lct-wc-size', getComputedStyle(el).fontSize);
            }
            if (el.getAttribute('data-lct-count') !== String(count)) el.setAttribute('data-lct-count', count);
        });
    };

    // Utilisés par la page liste de souhaits
    window.lctWishlistCountRefresh = apply;
    window.lctWishlistSetCount = (count) => {
        pageCount = Number.isInteger(count) ? count : null;
        apply();
    };

    const start = () => {
        apply();
        // L'app réécrit son chiffre après chaque ajout / suppression : on recalcule le nôtre
        // (on n'observe que le texte, pas nos attributs : aucune boucle possible)
        let timer;
        document.querySelectorAll('.wishlist-total-count').forEach((el) => {
            new MutationObserver(() => {
                clearTimeout(timer);
                timer = setTimeout(apply, 50);
                setTimeout(apply, 500); // au cas où l'app met à jour son cookie juste après
            }).observe(el, { childList: true, characterData: true, subtree: true });
        });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
})();